<template>
    <div class="floor-style-2 floor-wsw floors_border floor-bgImg-box" :id="data.block_name + c_index">
        <div class="floor-head-wrap" v-if="data.value.title.value.text">
            <h2 @click="$router.pushToTab(data.value.title.value.link.url)"
                :style="{ color: data.value.title.value.color }">{{ data.value.title.value.text }}</h2>
                <template v-if="data.value.subTitle.value.text">
                    <p @click="$router.pushToTab(data.value.subTitle.value.link.url)" :style="{ color: data.value.subTitle.value.color }">{{ data.value.subTitle.value.text }}</p>
                </template>
        </div>
        <div class="body-wrap">
            <ul class="goods-list">
                <li class="hoverBox hoverBoder" v-for="(item, index) in data.value.goodsList.value.list" :key="index" :title="item.goods_name">
                    <goods-list-item :goods="item" :upDownLayout="true"></goods-list-item>
                </li>
            </ul>
        </div>
        <div class="bottom-wrap" v-if="data.value.bottomImg.value.url">
            <img :src="$img(data.value.bottomImg.value.url)"
                @click="$router.pushToTab(data.value.bottomImg.value.link.url)" />
        </div>
        <floorBgImg :info="data"></floorBgImg>
    </div>
</template>

<script>
import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
import goodsListItem from "@/components/goods-list-item/goods-list-item.vue";
import goodsPrice from '@/components/goods-price/goods-price.vue';
import shareCounter from "@/components/shareCounter.vue";
import { onTip } from "@/utils/tips";
import { mapGetters } from "vuex";
import floorBgImg from "./floor-bgImg.vue";
export default {
    name: "floor-style-2",
    components: {
        shareCounter,
        ctrlShowText,
        goodsPrice,
        goodsListItem,
        floorBgImg
    },
    props: {
        data: {
            type: Object
        },
        c_index: {
            type: Number
        }
    },
    data() {
        return {}
    },
    created() { },
    computed: {
        ...mapGetters(["defaultGoodsImage", "cartCount", "siteInfo", "member"]),
        logined: function () {
            return this.member !== undefined && this.member !== "" && this.member != {}
        }
    },
    methods: {
        upnumber(val) {
            this.number = val
        },
        goSku(item) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            if (onTip(item.sale_control?.view_price, item.sale_control?.is_member_by, this, item.sale_control?.not_buy_msg)) return
            this.$router.pushToTab("/sku-" + item.sku_id)
        },
        // 加入购物车
        joinCart(item,index) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            this.$store
                .dispatch("cart/add_to_cart", {
                    site_id: item.site_id,
                    sku_id: item.sku_id,
                    num: this.number
                })
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "加入购物车成功",
                            type: "success"
                        })
                    }
                })
                .catch(err => {
                    if (err.message === "token不存在") {
                        this.$router.pushToTab("/login")
                    } else {
                        this.$message.error(err.message);
                        if(typeof err.data === 'number'){
                            if(err.data > 0){
                                this.$refs['shareCounter'+index][0].upnumber(err.data);
                                this.$message({
                                    message: "当前数量已更改为可购买数量，请重试加入购物车",
                                    type: "success"
                                });
                            }else{
                                window.location.reload();
                            }
                        }
                    }
                })
        },
        imageError(index) {
            this.data.value.goodsList.value.list[index].goods_image = this.defaultGoodsImage
        }
    }
}
</script>

<style lang="scss">
.floor-head-wrap,.body-wrap,.bottom-wrap{
    position: relative;
    z-index: 2;
}
.floor-style-2 {
    background-color: #fff;
    margin-top: 20px;
    .floor-head-wrap {
        text-align: center;
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        h2 {
            line-height: 30px;
            color: #333;
            font-size: 22px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        p {
            color: #b0b0b0;
            padding: 0 10px;
            font-size: 14px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .body-wrap {
        padding: 0 12px 12px 12px;
        box-sizing: border-box;
        .goods-list {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            li {
                width: calc((100% - 48px) / 5);
                background: #fff;
                cursor: pointer;
                padding: 12px;
                border-radius: 12px;
                transition: all 0.2s linear;
                border: 1px solid #dddddd6e;
                box-sizing: border-box;

                &:hover {
                    z-index: 2;
                    -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    -webkit-transform: translate3d(0, -2px, 0);
                    transform: translate3d(0, -2px, 0);
                    border: 1px solid #dddddd6e;
                }
            }
        }

        .bottom-wrap {
            margin-top: 10px;
            width: $width;
            //height: 118px;
            cursor: pointer;
            overflow: hidden;

            img {
                max-width: 100%;
            }
        }
    }
}
</style>
